import { Box } from "@mui/material";
import AssetsBreakdown from "./mssp_widgets/assets_breakdown/AssetsBreakdown";
import StackUtilizationAndCoverage from "./mssp_widgets/stack_utilization_coverage/StackUtilizationAndCoverage";
import TopIssuesTable from "./mssp_widgets/top_issues/TopIssuesTable";
const MSSPDashboard = () => {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <AssetsBreakdown />
      <StackUtilizationAndCoverage />
      <TopIssuesTable />
    </Box>
  );
};

export default MSSPDashboard;
